import * as React from "react";
import { ResponsivePie } from '@nivo/pie';
import pieData from "../../assets/data/samplepiedata";


export default class BarGraph extends React.Component {
  render() {
    const { realData, onSliceClick } = this.props;

    return (
      <div className="nivocontainer animated fadeInUp" style={{ width: "100%", height: "500px" }}>
        <ResponsivePie
          data={realData || pieData}
          margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
          innerRadius={0.5}
          padAngle={0.7}
          cornerRadius={3}
          colors={d => d.color}
          borderWidth={1}
          borderColor={{ from: 'color', modifiers: [ [ 'darker', 0.2 ] ] }}
          radialLabel="label"
          radialLabelsSkipAngle={10}
          radialLabelsTextXOffset={6}
          radialLabelsTextColor="#FFF"
          radialLabelsLinkOffset={0}
          radialLabelsLinkDiagonalLength={16}
          radialLabelsLinkHorizontalLength={24}
          radialLabelsLinkStrokeWidth={1}
          radialLabelsLinkColor={{ from: 'color' }}
          slicesLabelsSkipAngle={10}
          slicesLabelsTextColor={d => d.textColor}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          enableSlicesLabels={false}
          sortByValue={true}
          activeInnerRadiusOffset={26}
          activeOuterRadiusOffset={4}
          tooltip={d => {
            return (
                <strong>{d.label}</strong>
            );
          }}
          legends={[
            {
              anchor: 'bottom',
              direction: 'row',
              translateY: 56,
              itemWidth: 160,
              itemHeight: 18,
              itemTextColor: '#FFF',
              symbolSize: 18,
              symbolShape: 'circle',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemTextColor: '#acff24'
                  }
                }
              ],
              itemOpacity: 0,
            }
          ]}
          onClick={(data, e) => onSliceClick(data.id)(e)}
      />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/DataViz/pie.Component.js